import React, { CSSProperties } from 'react';
import ReactModal from 'react-modal';

interface IProps {
  isOpen: boolean;
}

/** @see http://reactcommunity.org/react-modal/accessibility/#app-element */
if (process.env.NODE_ENV !== 'test') {
  ReactModal.setAppElement('#root');
}

const ModalContainer: React.FC<IProps> = ({ isOpen, children }) => {
  return (
    <ReactModal isOpen={isOpen} style={{ content: customStyles.content, overlay: customStyles.overlay }}>
      {children}
    </ReactModal>
  );
};

const customStyles: ReactModal.Styles = {
  content: {
    borderRadius: 0,
    borderWidth: '4px',
    borderColor: '#000000',
    bottom: 'unset',
    maxWidth: '400px',
    position: 'static',
    margin: '40px auto',
  } as CSSProperties,
  overlay: {
    zIndex: 99,
    paddingLeft: '20px',
    paddingRight: '20px',
  } as CSSProperties,
};

export default ModalContainer;
